/**
 * 01. for product has custom bold options with size selection
 */
const BoldOptionSize = {
  initialActive: function () {
    const $ = jQuery;
    const varianWrapper = $(".variant-input-wrap .variant-input input");

    if (varianWrapper) {
      $(varianWrapper).each(function (index, item) {
        const isActive = $(item).is(":checked");
        if (isActive) {
          BoldOptionSize.setActive(index);
        }
      });
    }
  },
  setActive: function (selIndex) {
    const $ = jQuery;
    const tag = "SIZEBOLD";
    if (product_tags.includes(tag)) {
      const selectors = $(`.bold_options .bold_option_value`);
      if (selectors) {
        const selItem = $(selectors)[selIndex];
        if (selItem) {
          const input = $(selItem).find("label");
          if (input) {
            $(input).trigger("click");
          }
        }
      }
    }
  },
};

const DirectBuy = function () {
  const findButton = document.getElementById("button-direct-to-cart");

  if (findButton) {
    const items = {
      properties: {},
    };

    if (gsInventoryDefaultV) {
      items.id = gsInventoryDefaultV;
    }

    const radio = document.querySelectorAll(
      "fieldset input[type=radio]:checked",
    );
    document.addEventListener("variant:change", (e) => {
      if (e.detail && e.detail.variant) {
        items.id = e.detail.variant.id;
      }
    });

    findButton.addEventListener("click", function (event) {
      event.preventDefault();

      const updatedRadio = document.querySelectorAll(
        "fieldset input[type=radio]:checked",
      );
      const total = document.querySelector("input[name=quantity]");
      if (!total) return;

      if (updatedRadio) {
        updatedRadio.forEach(function (item) {
          // Native Shopify variant options are already represented by the
          // variant ID. Only custom radio options should become line-item
          // properties.
          if (item.hasAttribute('data-variant-input')) return;
          if (!item.name) return;
          items.properties[item.name] = item.value;
        });
      }

      items.quantity = total.value;

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: [items],
        },
        dataType: "json",
        success: function (data) {
          document.location.href = "/cart";
        },
        error: function (error) {
          console.error("Error adding to cart:", error);
        },
      });
    });
  }
};

/**
 * 02. Custom event for product 6677952594038
 **/

const CustomEventProduct = {
  addedCurrency: false,
  getActiveVariantPrice: function (selected) {
    const detail = meta.product.variants.find(
      (item) => item.public_title === selected,
    );

    if (detail) {
      const priceRaw = (detail.price * (100 - bulk_discount)) / 100;
      const price = Math.round(priceRaw / 100);
      jQuery(".bs__bulk-price").html(`${Shopify.formatMoney(price * 100)}`);
      CustomEventProduct.getComparePrice(selected);
    }
  },

  checkerInput: function () {
    const $ = jQuery;
    const hasCustomEvent = window.product_tags.includes("BSCBOLD");
    const buttons = jQuery(".product-section").find(".variant-input label");

    if (buttons) {
      $(buttons).each(function (index, item) {
        item.addEventListener("click", function (e) {
          const title = $(item).text();
          CustomEventProduct.getActiveVariantPrice(title);
          if (!CustomEventProduct.addedCurrency && hasCustomEvent) {
            CustomEventProduct.addedCurrency = true;
          }

          BoldOptionSize.setActive(index);
        });
      });
    }
  },

  getComparePrice: function (name) {
    const detail = productVariants.find((item) => item.public_title === name);
    const comparePriceContainer = jQuery(".bs__compare-price-sale");
    if (detail.compare_at_price) {
      const compare_price = theme.Currency.formatMoney(
        detail.compare_at_price,
        theme.settings.moneyFormat,
      );
      if (comparePriceContainer.length > 0) {
        comparePriceContainer[0].innerHTML = compare_price;
      } else {
        jQuery(".__price-container").append(
          jQuery(`<div class="bs__compare-price-sale">${compare_price}</div>`),
        );
      }
    } else {
      if (comparePriceContainer.length > 0) {
        comparePriceContainer[0].innerHTML = "";
      }
    }
  },

  init: function () {
    if (window.is_product_page) {
      this.checkerInput();
      BoldOptionSize.initialActive();
    }
  },
};

const Variant = {
  isSelectedVariant: function () {
    const selected = jQuery(".variant-input input").is(":checked");
    if (selected) {
      const label = jQuery(".variant-input input[checked]").val();
      Variant.disabledSizeInput(label);
    }
  },

  exToSelectSize: function () {
    if (window.exclusionVariantToSelectSize) {
      jQuery(".bs_size-before-qty-input").addClass("loaded");
      Variant.isSelectedVariant();
      const variantLabel = jQuery(".variant-input");
      const excludeVariant = exclusionVariantToSelectSize.split(":");

      if (variantLabel && excludeVariant) {
        jQuery(variantLabel).each(function (item) {
          jQuery(this).click(function () {
            const id = jQuery(this).find("label").text();
            Variant.disabledSizeInput(id);
          });
        });
      }
    }
  },

  disabledSizeInput: function (id) {
    if (!window.exclusionVariantToSelectSize) return;
    const excludeVariant = exclusionVariantToSelectSize.split(":");
    const note = jQuery("#bs__note-variant");

    if (id === excludeVariant[1]) {
      jQuery(".bs_size-before-qty-input").css({
        opacity: 0.2,
        pointerEvents: "none",
      });

      note.html(
        '<input type="hidden" value="Size not valid" name="properties[Note]"/>',
      );
    } else {
      jQuery(".bs_size-before-qty-input").css({
        opacity: 1,
        pointerEvents: "auto",
      });

      note.html("");
    }
  },
};

const convertNumber = function (string) {
  const match = String(string || "").match(/\d+(\.\d+)?/g);
  return match ? parseFloat(match[0]) : 0;
};

const formatedGridItemPrice = function (
  classFinder = "",
  isMultiPrice = false,
  variantPrice = null,
) {
  const $ = jQuery;
  if (!classFinder) classFinder = ".formated-price";
  const findPrice = $(`${classFinder}`);

  if (findPrice) {
    $(findPrice).each(function (index, item) {
      let replaceSymbol = "$";
      const hiddenText = item.querySelector(".visually-hidden");

      if (hiddenText) {
        $(hiddenText).remove();
      }

      let priceStr = item.innerText;
      if (variantPrice) priceStr = variantPrice;
      item.setAttribute("data-price", convertNumber(item.innerHTML));

      let symbol = priceStr.replace(
        replaceSymbol,
        `<div class="symbol small-size">${replaceSymbol}</div>`,
      );

      symbol = symbol.replace("from", "from&nbsp;");
      symbol = symbol.replace(/\n/g, "");
      const number = symbol.split(".");
      const lastIndex = number.length - 1;
      const last = number[lastIndex];
      number[lastIndex] =
        `<div class="last-number small-size"><span style="display: none;">.</span>${last}</div>`;

      if (isMultiPrice) {
        item.innerHTML = number.join("");
        item.classList.add("formated-price", "__product-single__price");
        item.classList.add("active");
        return;
      }

      if (item.classList.contains("done-formated")) return;

      item.innerHTML = number.join("");
      item.classList.add("done-formated");
      item.classList.add("active");
    });
  }
};

const TopMenu = function () {
  const items = document.querySelectorAll(".top-menu__item");
  if (items) {
    items.forEach(function (item, index) {
      const removeActiveClass = function () {
        items.forEach(function (menu) {
          menu.classList.remove("active");
        });
      };

      item.addEventListener("mouseover", function () {
        removeActiveClass();
        item.classList.add("active");
      });

      item.addEventListener("mouseout", function () {
        removeActiveClass();
      });
    });
  }
};

const MenuChild = function () {
  const buttons = document.querySelectorAll(".link-container .arrow-down");
  const subs = document.querySelectorAll(".bs-subs");
  if (buttons) {
    buttons.forEach(function (item) {
        item.addEventListener("click", function () {
        const buttonId = item.id;
        const subMenu = buttonId.replace("btn-", "");
        const subMenuEl = document.getElementById(subMenu);
        if (!subMenuEl) return;

        buttons.forEach(function (button, index) {
          if (subs[index]) {
            subs[index].classList.remove("active");
          }
          button.classList.remove("active");
        });

        if (item.classList.contains("active")) {
          subMenuEl.classList.remove("active");
          item.classList.remove("active");
        } else {
          subMenuEl.classList.add("active");
          item.classList.add("active");
        }
      });
    });
  }
};

const Tabs = function () {
  const getTabs = document.getElementById("product-detail-tabs");
  const prodRecommendationContainer = document.getElementById(
    "shopify-section-product-recommendations",
  );
  const tabContent = document.getElementById("product-recommendation-tab");
  if (getTabs) {
    const tabMenuId = "complete-the-look-tab-menu";
    const tabs = getTabs.querySelectorAll(".tab");
    const tabNavigation = getTabs.querySelector(".tab-navigation");
    const buttonCompleteTheLook = document.createElement("div");
    buttonCompleteTheLook.classList.add("tab-navigation__item");
    buttonCompleteTheLook.setAttribute("id", tabMenuId);
    buttonCompleteTheLook.innerText = "Similar Designs";

    if (tabContent) {
      const buttonLabel = tabContent.dataset.label;

      if (buttonLabel) {
        buttonCompleteTheLook.innerText = buttonLabel;
      }
    }

    const activeTabs = function (index = 0) {
      tabs.forEach(function (content, index) {
        content.classList.remove("active");
      });

      if (tabs[index]) {
        tabs[index].classList.add("active");
      }
    };

    activeTabs(0);

    if (tabs) {
      tabs.forEach(function (tab, index) {
        const nav = document.createElement("div");
        nav.classList.add("tab-navigation__item");
        const regex = /<p><strong>(.*?)<\/strong><\/p>/;
        const match = tab.innerHTML.match(regex);

        if (match) {
          nav.innerHTML = match[1];

          if (match[1]) {
            tabNavigation.appendChild(nav);
          }
        }
      });

      tabNavigation.appendChild(buttonCompleteTheLook);

      const navs = document.querySelectorAll(".tab-navigation__item");

      if (navs) {
        if (navs[0]) {
          navs[0].classList.add("active");
        }
        navs.forEach(function (nav, index) {
          nav.addEventListener("click", function (ev) {
            navs.forEach(function (button) {
              button.classList.remove("active");
            });

            navs[index].classList.add("active");

            activeTabs(index);

            if (nav.id === tabMenuId) {
              if (prodRecommendationContainer) {
                const wrapper = tabContent.querySelector(".item-slider");
                const navigation =
                  tabContent.querySelectorAll(".button-navigation");
                const listing = prodRecommendationContainer.querySelector(
                  ".product-recommendations-placeholder",
                );

                if (tabContent) {
                  if (!wrapper || !listing) return;
                  wrapper.innerHTML = listing.innerHTML;

                  const grid = tabContent.querySelector(".grid");
                  var flick = null;
                  setTimeout(function () {
                    //     flick = new Flickity(grid, {
                    //       cellAlign: "left",
                    //       prevNextButtons: false,
                    //       initialIndex: 2,
                    //       //       groupCells: true,
                    //       adaptiveHeight: true,
                    //     });
                    //     flick.on("settle", function (index) {
                    //       const totalSlide = flick.slides.length;
                    //       if (index === totalSlide - 1) {
                    //         navigation[1].classList.add("disabled");
                    //       } else {
                    //         navigation[1].classList.remove("disabled");
                    //       }
                    //     });
                  }, 50);

                  if (navigation) {
                    navigation[0].addEventListener("click", function () {
                      if (!flick) return;
                      flick.previous();
                      if (flick.selectedIndex === 0) {
                        navigation[0].classList.add("disabled");
                      }
                    });

                    navigation[1].addEventListener("click", function () {
                      if (!flick) return;
                      flick.next();
                      navigation[0].classList.remove("disabled");
                    });
                  }
                }
              }
            }
          });
        });
      }
    }
  }
};

const ProductDetailLabelNews = function () {
  const labels = document.querySelectorAll(".label-new");
  if (!labels) return;
  labels.forEach(function (label) {
    const date = label.dataset.published;
    const targetDate = new Date(date);

    // Current date

    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const timeDifference = currentDate - targetDate;

    const days = 90;
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    // Two weeks in milliseconds
    const milliseconds = days * millisecondsInADay;

    // Check if the time difference is greater than or equal to two weeks
    if (timeDifference >= milliseconds) {
    } else {
      label.classList.add("active");
    }
  });
};

const MoqDetail = function () {
  const buttons = document.querySelectorAll(".button-moq-detail");

  if (buttons) {
    const state = function () {
      const contentId = this.dataset.id;
      const moqContainer = document.querySelectorAll(".moq-container");
      const contentEl = document.getElementById(contentId);

      if (contentEl) {
        if (contentEl.classList.contains("active")) {
          contentEl.classList.remove("active");
        } else {
          moqContainer.forEach(function (box) {
            box.classList.remove("active");
          });

          contentEl.classList.add("active");
        }
      }
    };

    if (innerWidth < 600) {
      buttons.forEach(function (item) {
        item.addEventListener("click", state);
      });
    } else {
      buttons.forEach(function (item) {
        item.addEventListener("mouseover", state);

        item.addEventListener("mouseout", state);
      });
    }
  }
};

const CreateFormatPrice = function (price, sale) {
  var newPriceFormat = "";
  var normalPriceFormat = "";
  var salePriceFormat = "";
  if (price) {
    const priceToCurrFormat = (price / 100).toFixed(2);
    const split = priceToCurrFormat.split(".");
    normalPriceFormat = `<div class="formatted-price formatted-price__wrapper ${sale ? "red-price" : ""}"><div class="formatted-price__main">
                            <div class="curr-symbol">$</div>${split[0]}
                        </div>
                        <div class="formatted-price__decimal">
                            .${split[1]}
                        </div></div>`;
  }

  if (sale) {
    const priceSaleToCurrFormat = (sale / 100).toFixed(2);
    const split = priceSaleToCurrFormat.split(".");
    salePriceFormat = `<div class="bs__original-price formatted-price formatted-price__wrapper original-price"><div class="formatted-price__main">
                            <div class="curr-symbol">$</div>${split[0]}
                        </div>
                        <div class="formatted-price__decimal">
                            .${split[1]}
                        </div></div>`;
  }

  return `${normalPriceFormat} ${salePriceFormat}`;
};

jQuery(document).ready(function () {
  const $$ = jQuery;
  var icon = `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" fill="none"><path fill="#231F20" d="M3.41 6.71h-.827L0 .5h1.265L3 4.647 4.735.5H6L3.417 6.71H3.41Z"/></svg>`;
  jQuery(
    '<div class="quantity-nav"><div class="quantity-button quantity-up">' +
      icon +
      '</div><div class="quantity-button quantity-down">' +
      icon +
      "</div></div>",
  ).insertAfter(".quantity input");
  jQuery(".quantity").each(function () {
    var spinner = jQuery(this),
      btnUp = spinner.find(".quantity-up"),
      btnDown = spinner.find(".quantity-down");

    btnUp.click(function () {
      var disini = parseInt(spinner.find("input").val());

      spinner.find("input").val(disini + 1);
      spinner.find("input").trigger("change");

      baliswim().update_total();
    });

    btnDown.click(function () {
      var disini = parseInt(spinner.find("input").val());

      if (disini > 0) {
        spinner.find("input").val(disini - 1);
        spinner.find("input").trigger("change");
      }

      baliswim().update_total();
    });
  });

  Variant.exToSelectSize();

  CustomEventProduct.init();

  document.addEventListener("shopify:block:select", function (e) {
    if ($$(e.target).hasClass("bn-popup-announcement")) {
      $$(e.target).addClass("active");
      $$(e.target).find(".bn-popup-announcement").removeClass("active");

      $$(e.target)
        .find(".__pa-close-button")
        .click(function () {
          const id = $$(this).attr("data-block");
          $$(`.${id}`).removeClass("active");
        });
    }
  });

  document.addEventListener("shopify:block:deselect", function (e) {
    jQuery(".bn-popup-announcement").removeClass("active");
  });

  formatedGridItemPrice();

  document.addEventListener("variant:change", function (evt) {
    if (!evt.detail || !evt.detail.variant) return;

    setTimeout(function () {
      const price = (evt.detail.variant.price / 100).toFixed(2);

      // if(findPriceWrapper){
      const split = price.split(".");

      if (evt.detail.variant.price !== evt.detail.variant.compare_at_price) {
        var findPriceWrapper = document.querySelector(
          ".price-wrapper__value.product__price.on-sale",
        );

        if (!findPriceWrapper) {
          findPriceWrapper = document.querySelector(
            ".price-wrapper__value.product__price",
          );
        }

        if (findPriceWrapper) {
          const parent = findPriceWrapper.parentNode;
          if (!parent.classList.contains("compare-price-active")) {
            parent.classList.add("compare-price-active");
          }
          findPriceWrapper.innerHTML = CreateFormatPrice(
            evt.detail.variant.price,
            evt.detail.variant.compare_at_price,
          );
        }
      } else {
        const findPriceWrapper = document.querySelector(
          ".bs__single-price .product__price",
        );
        const findPriceWrapperSamlpe = document.querySelector(
          ".bs__single-price .sample",
        );
        if (findPriceWrapper) {
          findPriceWrapper.innerHTML = CreateFormatPrice(
            evt.detail.variant.price,
            null,
          );
        } else {
          if (findPriceWrapperSamlpe) {
            findPriceWrapperSamlpe.innerHTML = CreateFormatPrice(
              evt.detail.variant.price,
              null,
            );
          }
        }
      }

      // findPriceWrapper.innerHTML = `<div class="formatted-price formatted-price__wrapper"><div class="formatted-price__main">
      //                                   <div class="curr-symbol">$</div>${split[0]}
      //                               </div>
      //                               <div class="formatted-price__decimal">
      //                                   .${ split[1] }
      //                               </div></div>`
      // }

      // formatedGridItemPrice('.__sample-price-container .product__price', true, `$${price}`)
    }, 10);
  });

  const buttonWishlist = document.getElementById("show-wishlist");
  if (buttonWishlist) {
    buttonWishlist.addEventListener("click", () => {
      const widgetButton = document.getElementById("ssw-fave-side-button");
      if (widgetButton) {
        widgetButton.click();
      }
    });
  }

  TopMenu();

  Tabs();

  ProductDetailLabelNews();

  MenuChild();

  MoqDetail();

  DirectBuy();
});
